import React from 'react';

export default function PageFooter() {
	return (
		<div id="footer">
			<p> Handcrafted with ♥ by <a style={{border: "none"}} href="#/">Naman Sancheti.</a></p>
		</div>
	);
}
